import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "La mejor experiencia gastronómica costera que he tenido. Los mariscos son increíblemente frescos y el servicio es excepcional. ¡Volveré cada vez que visite la ciudad!",
      author: "María Fernández",
      role: "Cliente frecuente",
      rating: 5,
    },
    {
      id: 2,
      text: "El arroz marinero es simplemente espectacular. Puedes sentir la pasión que ponen en cada plato. El ambiente frente al mar hace que la experiencia sea aún más especial.",
      author: "Roberto Gómez",
      role: "Chef aficionado",
      rating: 5,
    },
    {
      id: 3,
      text: "Visitamos La Barra Brava durante nuestras vacaciones y quedamos encantados. Las empanadas de jaiba son adictivas y la parrillada de mariscos es abundante y sabrosa.",
      author: "Alejandra Torres",
      role: "Turista",
      rating: 4,
    },
    {
      id: 4,
      text: "Un lugar con encanto donde se puede disfrutar de mariscos de primera calidad con una vista impresionante. El personal es muy atento y conocedor del menú.",
      author: "Carlos Méndez",
      role: "Crítico gastronómico",
      rating: 5,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-rotation for testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <section className="py-20 bg-white relative">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="section-title inline-block">Lo Que Dicen Nuestros Clientes</h2>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Quote Icon */}
            <div className="absolute -top-10 left-0 text-6xl text-marina-200 opacity-50">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
            </div>

            {/* Testimonials */}
            <div className="relative overflow-hidden rounded-xl bg-marina-50 p-8 md:p-12 shadow-lg">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={testimonial.id}
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ 
                    opacity: activeIndex === index ? 1 : 0,
                    x: activeIndex === index ? 0 : 100,
                    position: activeIndex === index ? 'relative' : 'absolute'
                  }}
                  transition={{ duration: 0.5 }}
                  className="w-full"
                >
                  {activeIndex === index && (
                    <>
                      <p className="text-base sm:text-lg md:text-xl text-gray-700 italic mb-6">{testimonial.text}</p>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                        <div className="flex items-center">
                          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-marina-300 mr-3 sm:mr-4 flex-shrink-0"></div>
                          <div>
                            <h4 className="font-bold text-marina-800 text-sm sm:text-base">{testimonial.author}</h4>
                            <p className="text-xs sm:text-sm text-gray-500">{testimonial.role}</p>
                          </div>
                        </div>
                        <div className="flex sm:ml-auto">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className={`w-4 h-4 sm:w-5 sm:h-5 ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </motion.div>
              ))}
            </div>

            {/* Navigation dots */}
            <div className="flex justify-center mt-6 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleDotClick(index)}
                  className={`w-3 h-3 rounded-full ${
                    activeIndex === index ? 'bg-marina-600' : 'bg-marina-200'
                  } transition-colors duration-300`}
                  aria-label={`Ver testimonio ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
